export default __webpack_public_path__ + "static/media/video-a.224448c9.mp4";